module.exports = __webpack_public_path__ + "img/cjfwU7.626f8594.png";